import script from "./pay.vue?vue&type=script&setup=true&lang=js"
export * from "./pay.vue?vue&type=script&setup=true&lang=js"

import "./pay.vue?vue&type=style&index=0&id=3a7c9f2b&scoped=true&lang=less"

import exportComponent from "/data/opt/jenkins/workspace/prod/建博会大药房/dms-web-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7c9f2b"]])

export default __exports__